<template>
  <section class="page-container">
    <h1>Payment Link Sent</h1>
    <div class="border-box">
      <p>This payment link  has been sent to the customer's SMS/email address.</p>
      <v-button
        type="success"
        @click="routerToPolicy"
      >View Quote</v-button>

    </div>
    <h3>Add to Support Ticket</h3>
    <div class="flex">
      <div class="card left">
        <h3>Existing Support Ticket</h3>
        <v-input
          v-model="search"
          placeholder="Search by Ticket ID, Title"
          @keyEnter="filterData" />
        <div class="mg-b-10 mg-t-10">
          <v-checkbox-group
            :borderBlock="true"
            :list="typeOptions" />
        </div>
        <span class="client">
          client
          <span>{{ detailData.customer.isrd_nm }}</span>
        </span>
        <el-table
          :data="ticketList"
          stripe
          style="width: 100%"
          @row-click="rowClick">
          <!-- <el-table-column width="55">
            <template slot-scope="scope">
              <span
                :class="[selectIndex == scope.$index? 'radio-circle-checked': 'radio-circle' ]"
              ></span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="subject"
            label="Title"></el-table-column>
          <el-table-column
            label="Type">
            <template slot-scope="scope">
              <span class="span-checkbox">{{ scope.row.type_language }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"></el-table-column>
        </el-table>
        <!-- <div class="mg-t-15 text-right">
          <v-button
            :disabled="selectIndex == -1"
            type="info"
            @click="handlerAttach">Attach</v-button>
        </div> -->
      </div>
      <div class="card right">
        <h3>New Support Ticket</h3>
        <el-form
          ref="form"
          :rules="rules"
          :model="ticketForm">
          <div class="form-item">
            <span>Title</span>
            <el-form-item prop="subject">
              <v-input v-model="ticketForm.subject" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Remark</span>
            <v-input v-model="ticketForm.message" />
          </div>
          <div class="form-item">
            <span>Customer</span>
            <!--            <v-select-->
            <!--              v-model="customerId"-->
            <!--              :list="customerOptions"-->
            <!--              :disabled="true"-->
            <!--              :clearable="true" />         -->
            <!-- <v-select
              v-model="customerId"
              remote
              :remoteMethod="remoteMethodUser"
              :list="customerOptionsUser"
              :disabled="true"
              :clearable="true" /> -->
            <!-- 這裏只是顯示就可以了 -->
            <v-input
              :value="detailData.customer.isrd_nm"
              :disabled="true" />
          </div>
          <div class="form-item">
            <span>Assignee</span>
            <v-select
              v-model="ticketForm.assignee_id"
              :list="globalOptions.assignee" />
          </div>
        </el-form>
        <v-button
          type="primary"
          @click="createTicket">Create and View Ticket</v-button>
        <v-button
          type="success"
          @click="createTicket(3)">Create and Resolve Ticket</v-button>
      </div>
    </div>
  </section>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import { createGeneralTicket, getTicketRelationList, setTicketRelation } from '@/api/ticket'
import {
  getCarQuoteDetail,
  getHousemaidQuoteDetail,
  getInteriorQuoteDetail,
  getHomefireQuoteDetail } from '@/api/quote'
export default {
  name: 'sendLinkSuccess',
  mixins: [MixinOptions, MixinRules],
  data() {
    return {
      typeOptions: [
        {
          name: 'General',
          id: 1
        },
        {
          name: 'Refer Case',
          id: 2
        }
      ],
      search: '',
      ticketForm: {
        subject: '',
        assignee_id: '',
        // customer_id: '',
        message: ''
      },
      ticketList: [],
      detailData: {
        customer: {}
      },
      selectIndex: -1,
      // customerId: ''
    }
  },
  computed: {
    ...mapState('common', ['productId','customerOptionsUser']),

    orderId() {
      return this.$route.query.order_id
    },
    customerId() {
      return this.$route.query.customer_id
    },
    quoteNo() {
      return this.$route.query.quote_no
    }
  },
  // watch: {
  //   property: {
  //     immediate: true,
  //     handler() {
  //       if(this.productId == 12){

  //       }
  //       this.network().getCarQuoteDetail()
  //       this.network().getTicketRelationList()
  //     }
  //   }
  // },
  created() {
    // this.customerId = this.$route.query.customer_id

    switch(Number(this.productId)) {
      case 12:
        this.network().getHousemaidQuoteDetail()
        break
      case 11:
        this.network().getCarQuoteDetail()
        break
      case 15:
        this.network().getInteriorQuoteDetail()
        break
      case 17:
        this.network().getHomefireQuoteDetail()
        break
    }
    this.network().getTicketRelationList()
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),

    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    routerToPolicy() {
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: this.orderId,
          product_id:this.productId
        }
      })
    },
    clientClick() {

    },
    rowClick(row) {
      // this.selectIndex = row.index
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    filterData() {
      this.network().getTicketRelationList()
    },
    handlerAttach() {
      this.network().setTicketRelation()
    },
    createTicket(status) {
      this.$refs.form.validate(valid => {
        if(valid) {
          if(status) {
            this.network().createGeneralTicket({
              status: 3
            })
          } else {
            this.network().createGeneralTicket()
          }
          this.setCustomerOptionNUll()
        }
      })

    },
    network() {
      return {
        getCarQuoteDetail: async () => {
          let { data } = await getCarQuoteDetail({
            order_id: this.orderId
          })
          this.detailData = data
        },
        getHousemaidQuoteDetail: async () => {
          let { data } = await getHousemaidQuoteDetail({
            order_id: this.orderId
          })
          this.detailData = data
        },
        getInteriorQuoteDetail: async () => {
          let { data } = await getInteriorQuoteDetail({
            order_id: this.orderId
          })
          this.detailData = data
        },
        getHomefireQuoteDetail: async () => {
          let { data } = await getHomefireQuoteDetail({
            order_id: this.orderId
          })
          this.detailData = data
        },
        getTicketRelationList: async () => {
          const { data } = await getTicketRelationList({
            customer_id: this.customerId,
            search: this.search
          })
          // this.selectIndex = -1
          // data.map((item, index) => {
          //   item.index = index
          //   return item
          // })
          this.ticketList = data
        },
        setTicketRelation: async () => {
          const { data } = await setTicketRelation({
            id: this.ticketList[this.selectIndex].id,
            quote_no: this.quoteNo
          })
          this.$message({
            type: 'success',
            message: data.message_language? data.message_language: data.message
          })
        },
        createGeneralTicket: async (params = {}) => {
          const { data } = await createGeneralTicket({
            ...this.ticketForm,
            quote_no: this.quoteNo,
            customer_id: this.customerId,
            ...params
          })
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.id
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  h1 {
    padding-bottom: 5px;
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #d5d8de;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .flex {
    margin-top: 15px;
    .card {
      margin-right: 15px;
      width: 448px;
    }
    h3 {
      padding-bottom: 10px;
      font-size: 20px;
    }
    .left {
      padding: 15px 10px 15px 15px;
      border-right: 1px solid #dddfe7;

      .mg-t-10 {
        margin-top: 10px;
      }
      .mg-b-10 {
        margin-bottom: 10px;
      }
      .client {
        font-size: 16px;
        font-weight: 500;
        & > span {
          display: inline-block;
          padding-left: 5px;
          font-weight: 400;
        }
      }
    }
    .right {
      padding: 15px 15px 15px 10px;
    }
  }
  .border-box{
    p{
      padding:32px 0 16px 0;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
    }
    padding-bottom: 16px;
    border-top: 1px solid #E1E4E8;
    border-bottom: 1px solid #E1E4E8;
    margin-bottom: 31px;
  }
}
</style>

